import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import moment from "moment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loadingVisible: false,
    hash: null,
    role: null,
    idUnit: null,
    checkResult: null,
    url: "https://sklad.gpsdozor.cz",
    companies: []
  },
  mutations: {
    showLoading: state => (state.loadingVisible = true),
    hideLoading: state => (state.loadingVisible = false),
    saveState: state => {
      if (state.hash === null) {
        localStorage.removeItem("hash");
      } else {
        localStorage.setItem("hash", state.hash);
      }
      if (state.role === null) {
        localStorage.removeItem("role");
      } else {
        localStorage.setItem("role", state.role);
      }
      if (state.idUnit === null) {
        localStorage.removeItem("idUnit");
      } else {
        localStorage.setItem("idUnit", state.idUnit);
      }
      if (state.checkResult === null) {
        localStorage.removeItem("checkResult");
      } else {
        localStorage.setItem("checkResult", JSON.stringify(state.checkResult));
      }
      let companies = state.companies;
      if (state.companies.length > 3) {
        companies = state.companies.slice(
          state.companies.length - 3,
          state.companies.length
        );
      }
      localStorage.setItem("companies", JSON.stringify(companies));
    },
    loadState: state => {
      state.hash = localStorage.getItem("hash");
      state.role = localStorage.getItem("role");
      state.idUnit = localStorage.getItem("idUnit");
      state.checkResult = JSON.parse(localStorage.getItem("checkResult"));
      if (localStorage.getItem("companies")) {
        state.companies = JSON.parse(localStorage.getItem("companies"));
      }
    },
    resetState: state => {
      state.hash = null;
      state.role = null;
      state.idUnit = null;
      state.checkResult = null;
      state.companies = [];
    }
  },
  actions: {
    async login({ state }, payload) {
      const result = await axios.post(state.url + "/api/loginserviceapp", {
        nick: payload.login,
        password: payload.password
      });

      if (result.data.status == 200) {
        state.hash = result.data.hash;
        state.role = result.data.role;
        return true;
      }

      return false;
    },
    async logout({ state }) {
      const result = await axios.post(
        state.url + "/api/logoutserviceapp",
        {},
        {
          headers: {
            Authorization: state.hash
          }
        }
      );

      if (result.data.status == 200) {
        state.idUnit = null;
        state.checkResult = null;
        state.hash = null;
        state.role = null;
        return true;
      }

      if (result.data.status == 400) {
        state.hash = null;
        state.role = null;
      }

      return false;
    },
    async check({ state }, payload) {
      try {
        const result = await axios.post(
          state.url + "/api/checkserviceapp",
          {
            id: payload.idUnit
          },
          {
            headers: {
              Authorization: state.hash
            }
          }
        );

        if (result.data.status == 200) {
          state.idUnit = payload.idUnit;
          state.checkResult = result.data;
          state.checkResult.timestamp = moment();
          state.checkResult.fuelStateTimestamp = moment(
            state.checkResult.fuelStateTimestamp
          ).format("DD.MM.YYYY HH:mm");
          state.checkResult.batteryTimestamp = moment(
            state.checkResult.batteryTimestamp
          ).format("DD.MM.YYYY HH:mm");
          state.checkResult.odometerTimestamp = moment(
            state.checkResult.odometerTimestamp
          ).format("DD.MM.YYYY HH:mm");
          state.checkResult.driverCardTimestamp = moment(
            state.checkResult.driverCardTimestamp
          ).format("DD.MM.YYYY HH:mm");

          let fuelStateHours = moment().diff(
            moment(state.checkResult.fuelStateTimestamp, "DD.MM.YYYY HH:mm"),
            "hours"
          );

          state.checkResult.fuelStateTimestampValid = fuelStateHours < 1;

          let batteryHours = moment().diff(
            moment(state.checkResult.batteryTimestamp, "DD.MM.YYYY HH:mm"),
            "hours"
          );
          state.checkResult.batteryTimestampValid = batteryHours < 1;

          let odometerHours = moment().diff(
            moment(state.checkResult.odometerTimestamp, "DD.MM.YYYY HH:mm"),
            "hours"
          );

          state.checkResult.odometerTimestampValid = odometerHours < 1;

          if (state.checkResult.hasDriverIdentification) {
            state.checkResult.driverCardValue = true;
            state.checkResult.driverCardTimestampValid = true;
          } else {
            state.checkResult.driverCardValue = false;
            state.checkResult.driverCardTimestampValid = false;
          }
          // let driverCardHours = moment().diff(moment(state.checkResult.driverCardTimestamp), 'hours');
          // state.checkResult.driverCardTimestampValid = (driverCardHours <= 1);

          return true;
        }

        if (result.data.status == 400) {
          state.hash = null;
        }
      } catch (Exception) {
        return false;
      }

      return false;
    },
    async save({ state }, payload) {
      console.log(payload);
      const result = await axios.post(
        state.url + "/api/saveserviceapp",
        {
          id: state.idUnit,
          client: payload.client,
          name: payload.name,
          plate: payload.plate,
          color: payload.color,
          type: payload.type,
          tachometer: payload.tachometer,
          isInOrion: state.checkResult.isInOrion,
          hasValidGpsPosition: state.checkResult.hasValidGpsPosition,
          hasIgnitionOn: state.checkResult.hasIgnitionOn,
          hasIgnitionOff: state.checkResult.hasIgnitionOff,
          hasTrip: state.checkResult.hasTrip,
          hasTripTypeSwitch: state.checkResult.hasTripTypeSwitch,
          hasDriverIdentification: state.checkResult.hasDriverIdentification,
          typeMontage: payload.typeMontage,
          priceMontage: payload.price,
          accountKm: payload.km,
          note: payload.note,
          checkCan: payload.checkCan,
          checkTacho: payload.checkTacho,
          checkBasic: payload.checkBasic,
          originalId: payload.originalId
        },
        {
          headers: {
            Authorization: state.hash
          }
        }
      );

      if (result.data.status == 200) {
        return true;
      }

      if (result.data.status == 400) {
        state.hash = null;
      }

      return false;
    },
    async history({ state }, payload) {
      const result = await axios.post(
        state.url + "/api/historyserviceapp",
        {
          date: payload.date
        },
        {
          headers: {
            Authorization: state.hash
          }
        }
      );

      if (result.data.status == 200) {
        return result.data.message;
      }

      if (result.data.status == 400) {
        state.hash = null;
      }

      return false;
    },
    async editUnit({ state }, payload) {
      console.log(payload);
      const result = await axios.post(
        state.url + "/api/saveserviceapp",
        {
          client: payload.unit.client,
          name: payload.unit.name,
          plate: payload.unit.plate,
          color: payload.unit.color,
          type: payload.unit.type,
          tachometer: payload.unit.tachometer,
          typeMontage: payload.unit.typeMontage,
          priceMontage: payload.unit.price,
          accountKm: payload.unit.km,
          note: payload.unit.note,
          checkCan: payload.unit.checkCan,
          checkTacho: payload.unit.checkTacho,
          checkBasic: payload.unit.checkBasic,
          originalId: payload.unit.id
        },
        {
          headers: {
            Authorization: state.hash
          }
        }
      );

      if (result.data.status == 200) {
        return true;
      }

      if (result.data.status == 400) {
        state.hash = null;
      }

      return false;
    },
    async deleteUnit({ state }, payload) {
      const result = await axios.post(
        state.url + "/api/deleteserviceapp",
        {
          client: payload.unit.client,
          name: payload.unit.name,
          plate: payload.unit.plate,
          color: payload.unit.color,
          type: payload.unit.type,
          tachometer: payload.unit.tachometer,
          typeMontage: payload.unit.typeMontage,
          priceMontage: payload.unit.price,
          accountKm: payload.unit.km,
          note: payload.unit.note,
          originalId: payload.unit.id
        },
        {
          headers: {
            Authorization: state.hash
          }
        }
      );

      if (result.data.status == 200) {
        return true;
      }

      if (result.data.status == 400) {
        state.hash = null;
      }

      return false;
    },
    async getUnit({ state }, payload) {
      const result = await axios.post(
        state.url + "/api/getmountedunitserviceapp",
        {
          id: payload.unit.id
        },
        {
          headers: {
            Authorization: state.hash
          }
        }
      );

      if (result.data.status == 200) {
        return result.data.message;
      }

      if (result.data.status == 400) {
        state.hash = null;
      }

      return false;
    },
    async getInstructions({ state }, payload) {
      const result = await axios.get(
          "https://beta.gpsdozor.cz/API/ServiceAppInstructions.php",
        {
          params:{
            main: (payload.main == "")?null:payload.main,
            type: (payload.type == "")?null:payload.type,
            brand: (payload.brand == "")?null:payload.brand
          }
        }
      );

      if (result.data.status == 200) {
          return result.data.data;
      }

      // return false;
    }
  },
  modules: {}
});
